module.exports = __webpack_public_path__ + "static/goldMicrosoftPartner-88f421bde991234eada890134c327ece.svg";